import {
  GET_DELIVERY_MEN_SUCCESS,
  GET_DELIVERY_MEN_FAIL,
  GET_DELIVERY_MAN_SUCCESS,
  GET_DELIVERY_MAN_FAIL,
  CREATE_DELIVERY_MAN_SUCCESS,
  CREATE_DELIVERY_MAN_FAIL,
  UPDATE_DELIVERY_MAN_SUCCESS,
  UPDATE_DELIVERY_MAN_FAIL,
  DELETE_DELIVERY_MAN_SUCCESS,
  DELETE_DELIVERY_MAN_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  deliveryMen: [],
  selectedDeliveryMan: null,
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
}

const DeliveryMenReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get all delivery men
    case "GET_DELIVERY_MEN":
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_DELIVERY_MEN_SUCCESS:
      return {
        ...state,
        loading: false,
        deliveryMen: action.payload,
        error: null,
      }

    case GET_DELIVERY_MEN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get single delivery man
    case "GET_DELIVERY_MAN":
      return {
        ...state,
        loading: true,
        selectedDeliveryMan: null,
        error: null,
      }

    case GET_DELIVERY_MAN_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedDeliveryMan: action.payload,
        error: null,
      }

    case GET_DELIVERY_MAN_FAIL:
      return {
        ...state,
        loading: false,
        selectedDeliveryMan: null,
        error: action.payload,
      }

    // Create delivery man
    case "CREATE_DELIVERY_MAN":
      return {
        ...state,
        loading: true,
        createSuccess: false,
        error: null,
      }

    case CREATE_DELIVERY_MAN_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: true,
        error: null,
      }

    case CREATE_DELIVERY_MAN_FAIL:
      return {
        ...state,
        loading: false,
        createSuccess: false,
        error: action.payload,
      }

    // Update delivery man
    case "UPDATE_DELIVERY_MAN":
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        error: null,
      }

    case UPDATE_DELIVERY_MAN_SUCCESS:
      // Update the delivery man in the list with the fetched data
      const updatedDeliveryMan = action.payload
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        deliveryMen: state.deliveryMen.map(dm =>
          dm.id === updatedDeliveryMan.id ? updatedDeliveryMan : dm
        ),
        selectedDeliveryMan: state.selectedDeliveryMan?.id === updatedDeliveryMan.id
          ? updatedDeliveryMan
          : state.selectedDeliveryMan,
        error: null,
      }

    case UPDATE_DELIVERY_MAN_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        error: action.payload,
      }

    // Delete delivery man
    case "DELETE_DELIVERY_MAN":
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
        error: null,
      }

    case DELETE_DELIVERY_MAN_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        error: null,
      }

    case DELETE_DELIVERY_MAN_FAIL:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default DeliveryMenReducer
